import React from "react";

import { Avatar } from "@performyard/py-components";

import ExpandableText from "../../../../components/ExpandableText";

type PanelHeaderCardProps = {
	name: string;
	isCompanyWide: boolean;
	assignee?: { _id: string; name: string };
	description?: string;
};

const PanelHeaderCard = ({ name, isCompanyWide, assignee, description }: PanelHeaderCardProps): React.ReactElement => {
	const hasDescription = Boolean(description?.trim());

	return (
		<div className="flex flex-col gap-2">
			<div className="flex flex-col gap-1 rounded-1 bg-neutral-1 p-3">
				<span className="text-paragraph-1 font-semibold [overflow-wrap:anywhere] text-neutral-9">{name}</span>
				{assignee && (
					<p className="flex items-center gap-1.5 text-paragraph-3 text-neutral-9">
						<span className="font-semibold">Assignee:</span>
						<Avatar id={assignee._id} name={assignee.name} title={assignee.name} size={20} />
						<span className="[overflow-wrap:anywhere]">{assignee.name}</span>
					</p>
				)}
				<p className="text-paragraph-3 text-neutral-9">
					<span className="font-semibold">Type:</span>{" "}
					{isCompanyWide ? "Company Wide Competency" : "Role Specific Competency"}
				</p>
			</div>

			{hasDescription && <ExpandableText content={description ?? ""} className="[overflow-wrap:anywhere]" />}
		</div>
	);
};

export default PanelHeaderCard;
